import PageWrapper from "@components/UI/PageWrapper/Index";
import { useGenericReducer } from "@hooks/state/useGenericReducer";
import CreateTemplateEmail from "@components/TemplateEmail/Create/Index";
import FiltroTemplateEmail from "@components/TemplateEmail/Filter/Index";

const PageTemplateEmail = () => {
    const { state, setData, addItem, updateItem, deleteItem } = useGenericReducer();

    return (
        <PageWrapper>
            <CreateTemplateEmail
                addItem={addItem}
            />
            <FiltroTemplateEmail
                state={state}
                setData={setData}
                deleteItem={deleteItem}
                updateItem={updateItem}
            />
        </PageWrapper>
    );
};

export default PageTemplateEmail;